import moment from 'moment';

export const dateCurrencyFromatter = Object.seal({
  locale: 'en',
  currency: 'usd',

  dateFormats: {
    default: 'DD/MM/YYYY', // 22/9/2022
    shortDate: 'DD MMM', // 1 sep
    shortDateWithDay: 'ddd. DD MMM', // sun. 1 sep
    longDate: 'DD MMMM', // 1 september
    fullDate: 'DD MMMM YYYY', // 1 september 2022
    longDateWithDay: 'dddd, DD MMMM', //sunday, 1 september
    fullDateWithDay: 'dddd, DD MMMM YYYY', // sunday, 1 september 2022
    calendarFormat: 'YYYY-MM-DD', // 2022-11-9
    appointment: 'dddd, Do of MMMM', // sunday, 1st of september
    year: 'YYYY', // 2002
    monthName: 'MMMM', // september
    monthShortName: 'MMM', // sep
    monthNumber: 'MM', // 09
    monthShortNumber: 'M', //9
    dayName: 'dddd', // Sunday
    dayShortName: 'ddd', // sun
    dayNumber: 'DD', // 09
    dayShortNumber: 'D', //9
    timeStampWithDate: 'D MMMM h:mm a', //14 September 6:35 pm
    timeStamp: 'h:mm a', //6:35 pm
    fullDateWithFullTime: 'MMMM DD, YYYY HH:mm:ss', // sept 01, 2022 07:00:00
    fullDateWithShortTime: 'DD/MM/yyyy HH:mm', // 01/09/2022 07:00
    fullDateWithShortTimeWithDash: 'DD/MM/YYYY - HH:mm', // 01/09/2022 - 07:00
    yearMonthDayConcatinated: 'YYYYMMDD', //20220909
    timeStampCapital: 'hh:mm A', //06:35 PM
    monthNameAndYear: 'MMMM YYYY', //september 2022
    dayAndMonthName: 'D MMMM', //14 september
    oneDigitDayFullDate: 'D MMMM YYYY', //14 september 2022
    oneDigitDayShortMonthFullDate: 'D MMM YYYY', //14 sept 2022
    oneDigitDayShortDate: 'D MMM', // 1 sep

    ordinalShortDate: 'Do MMM', // 1st sep
    ordinalLongDate: 'Do MMMM', //3rd oct
    ordinalFullDate: 'Do MMMM YYYY', //1st september 2022
    ordinalFullDateWithShorMonthName: 'Do MMM YYYY', //1st sep 2022
    ordinalShortDateWithDay: 'ddd. Do MMM', // sun. 1st sep
    ordinalLongDateWithDay: 'dddd, Do MMMM', // sunday, 1st september
    ordinalFullDateWithDay: 'dddd, Do MMMM YYYY', // sunday, 1st september 2022
    ordinalFullDayOfFullMonth: 'dddd Do of MMMM', //sunday 1st of september
    ordinalFullDayOfShortMonth: 'dddd, Do of MMM', //sunday, 1st of sep
  },

  dateTransformer: function (date, dateFormat) {
    const localeDate = moment(date);
    localeDate.locale(dateCurrencyFromatter.locale);
    return localeDate.format(dateFormat);
  },

  currencyTransformer: function (value, minVal = 2) {
    return value?.toLocaleString(dateCurrencyFromatter.locale, {
      minimumFractionDigits: minVal,
      maximumFractionDigits: 2,
    });
  },
});
